import script from "./customersTable.vue?vue&type=script&setup=true&lang=js"
export * from "./customersTable.vue?vue&type=script&setup=true&lang=js"

import "./customersTable.vue?vue&type=style&index=0&id=b88310de&lang=scss"

const __exports__ = script;

export default __exports__